var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mx-auto",attrs:{"elevation":"0"}},[_c('v-navigation-drawer',{attrs:{"mini-variant":_vm.mini,"mini-variant-width":"40","permanent":"","floating":""}},[_c('v-list',{staticClass:"pa-0",attrs:{"nav":""}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }